import { IBaseModel, BaseModel } from '../base.model';

export interface IBM extends IBaseModel { }
export class BM extends BaseModel { }



// WEBPACK FOOTER //
// ./src/models/bm/bm.model.ts